import { createContext, PropsWithChildren, useContext, useEffect } from "react";
import { selectAppLanguage } from "../../kiosk/components/LanguageSelector/useLanguage";
import { IntlProvider } from "react-intl";
import { useAppSelector } from "../utils/redux/store.tsx";
import { LANGUAGES } from "../../types/shared/language.ts";
import { createLanguageContext, createLanguageProvider } from "@jamezz/react-components";

const LanguageContext = createLanguageContext(LANGUAGES, createContext);

export const LanguageProvider = createLanguageProvider(LANGUAGES, LanguageContext);
export const useLanguage = () => useContext(LanguageContext);

export default function JamezzIntlProvider(props: PropsWithChildren) {
  const selectedLanguage = useAppSelector(selectAppLanguage);
  const { locale, messages, changeLanguage } = useLanguage();

  useEffect(() => {
    changeLanguage(selectedLanguage);
  }, [selectedLanguage, changeLanguage]);

  // useEffect(() => {
  //   const element = document.querySelector("html");
  //   if (element) {
  //     element.setAttribute("lang", selectedLanguage);
  //     switch (selectedLanguage) {
  //       case "ar":
  //         element.setAttribute("dir", "rtl");
  //         break;
  //       default:
  //         element.setAttribute("dir", "ltr");
  //         break;
  //     }
  //   }
  // }, [selectedLanguage]);

  return (
    <IntlProvider locale={locale} messages={messages} onError={() => {}}>
      {props.children}
    </IntlProvider>
  );
}

export type DocDir = "rtl" | "ltr";

export function useDocumentDirection(): DocDir {
  return document.querySelector("html")?.getAttribute("dir") === "rtl" ? "rtl" : "ltr";
}
